import { Head } from 'features/head'
import { Suspense, lazy } from 'react'

const GamesList = lazy(() => import('features/games/index'))

export const GamesListPage: React.FC = () => {
  return (
    <>
      <Head title='Games List' />
      {/* TODO: Implement skeletons */}
      <Suspense fallback={<p>Loading...</p>}>
        <GamesList />
      </Suspense>
    </>
  )
}
